import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { ArrowUpRight } from "lucide-react";

export default function CategoryCard({ cat, index = 0 }) {
  const Icon = Icons[cat.icon] || Icons.Package;
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.5, delay: index * 0.04 }}
    >
      <Link
        to={`/products/${cat.slug}`}
        data-testid={`category-card-${cat.slug}`}
        className="gfe-gradient-border group relative flex flex-col h-full bg-white border border-slate-200 rounded-2xl p-6 hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
      >
        <div className="flex items-start justify-between mb-6">
          <span className="inline-flex items-center justify-center w-11 h-11 rounded-xl bg-slate-50 border border-slate-200 group-hover:bg-white transition">
            <Icon className="w-5 h-5 text-slate-800" strokeWidth={1.6} />
          </span>
          <ArrowUpRight className="w-5 h-5 text-slate-400 group-hover:text-slate-900 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all" />
        </div>
        <h3 className="font-display text-lg font-bold text-slate-900 leading-tight">{cat.name}</h3>
        <p className="text-xs uppercase tracking-widest text-slate-500 mt-1">{cat.tagline}</p>
        <p className="text-sm text-slate-600 mt-4 leading-relaxed line-clamp-3">{cat.description}</p>
        <div className="mt-5 pt-5 border-t border-slate-100 flex flex-wrap gap-1.5">
          {cat.brands.slice(0, 4).map((b) => (
            <span key={b} className="text-[11px] px-2 py-0.5 rounded-full bg-slate-50 text-slate-600 border border-slate-200">{b}</span>
          ))}
          {cat.brands.length > 4 && (
            <span className="text-[11px] px-2 py-0.5 rounded-full bg-slate-900 text-white">+{cat.brands.length - 4}</span>
          )}
        </div>
      </Link>
    </motion.div>
  );
}
